
const initialState = {
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_ROOT_EBAY_DATA': {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Ebay.reducer.js